import React from 'react';
import './ContactPage.css';

import Navigation from '../../Shared/Navigation/Navigation';

import Footer from '../../Shared/Footer/Footer';
// import Menu from '../../PageCompos/Home/Menu/Menu';
// import Review from '../../PageCompos/Home/Review/Review';
// import BottomBanner from '../../PageCompos/Home/BottomBanner/BottomBanner';
// import FindLocation from '../../PageCompos/Contact/FindLocation/FindLocation';
import ContactBanner from '../../PageCompos/Contact/ContactBanner/ContactBanner';
import ReachUs from '../../PageCompos/Contact/ReachUs/ReachUs';
import VisitDelicioz from '../../PageCompos/Contact/VisitDelicioz/VisitDelicioz';

const ContactPage = () => {
    return (
        <>
            <Navigation />
            <ContactBanner />
            <ReachUs />
            <VisitDelicioz />
            {/* <FindLocation /> */}
            <Footer />
        </>
    );
};

export default ContactPage;